import { render, staticRenderFns } from "./MemberMedalPop.vue?vue&type=template&id=011a1b85&scoped=true&"
import script from "./MemberMedalPop.vue?vue&type=script&lang=js&"
export * from "./MemberMedalPop.vue?vue&type=script&lang=js&"
import style0 from "./MemberMedalPop.vue?vue&type=style&index=0&id=011a1b85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011a1b85",
  null
  
)

export default component.exports